/**
 * URL de acceso por empresa (path fijo /login/:slug).
 * VITE_PUBLIC_APP_URL: enlace canónico para copiar (ej. demo/prod) aunque el admin esté en localhost.
 */
export function tenantLoginPath(slug) {
    const s = String(slug || '')
        .trim()
        .toLowerCase();
    if (!s) return '/login';
    return `/login/${encodeURIComponent(s)}`;
}

export function tenantLoginBaseUrl() {
    const fromEnv = (import.meta.env.VITE_PUBLIC_APP_URL || '').trim();
    if (fromEnv) return fromEnv.replace(/\/$/, '');
    if (typeof window !== 'undefined' && window.location?.origin) {
        return window.location.origin.replace(/\/$/, '');
    }
    return '';
}

export function tenantLoginUrl(slug, baseUrl) {
    const base = (baseUrl || tenantLoginBaseUrl()).replace(/\/$/, '');
    if (!base) return tenantLoginPath(slug);
    return `${base}${tenantLoginPath(slug)}`;
}

/** Texto listo para WhatsApp / correo al cliente. */
export function tenantLoginShareMessage({ name, slug, baseUrl, url: explicitUrl }) {
    const url = explicitUrl || tenantLoginUrl(slug, baseUrl);
    const label = name ? `ALINEA · ${name}` : 'ALINEA';
    return (
        `Tu acceso a ${label}:\n\n` +
        `${url}\n\n` +
        `Ingresa con tu código de empleado. Si eres supervisor o administrador, también necesitarás tu contraseña.`
    );
}
